import { jsx as _jsx } from "react/jsx-runtime";
import 'react';
import Spinner from '../spinner/Spinner';
const DropdownSpinner = ({ className }) => (_jsx("ul", Object.assign({ className: className }, { children: _jsx("div", Object.assign({ className: 'display-flex justify-content-center padding-10' }, { children: _jsx(Spinner, {}) })) })));
export default DropdownSpinner;
